export default __webpack_public_path__ + "static/media/serguei3.9ea41b98.jpg";